import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CognitoAuth } from 'amazon-cognito-auth-js';
import { CognitoUtil } from './cognito.service';
import jwtHelper from 'jwt-decode';
import { environment } from 'environments/environment';
import { AnalyticsService } from './analytics.service';

@Injectable()
export class GoogleAuthService {

    authData: any;
    auth: any;
    session: any;

    constructor(
        private router: Router,
        public cognitoUtil: CognitoUtil,
        private readonly analyticsService: AnalyticsService) {
    }

    async getAuthInstance() {
        return new Promise((resolve, reject) => {
            this.authData = {
                UserPoolId: this.cognitoUtil.getUserPool().getUserPoolId(),
                ClientId: this.cognitoUtil.getUserPool().getClientId(),
                RedirectUriSignIn: environment.redirectSignIn,
                RedirectUriSignOut: environment.redirectSignOut,
                AppWebDomain: environment.appDomain,
                TokenScopesArray: [],
                AdvancedSecurityDataCollectionFlag: false
            }

            this.auth = new CognitoAuth(this.authData);

            this.auth.userhandler = {
                onSuccess: async session => {
                    try {
                        this.session = session;
                        const jwtToken = session.getIdToken().getJwtToken();
                        const decodedJWT = jwtHelper(session.getIdToken().getJwtToken());

                        const email = decodedJWT['email'];
                        const sub = decodedJWT['sub'];
                        const identities = decodedJWT['identities'];
                        const identityInfo = identities[0];
                        const providerType = identityInfo['providerType'];

                        localStorage.setItem('CognitoSub', sub);
                        localStorage.setItem('Email', email);
                        localStorage.setItem('ProviderType', providerType);
                        await this.cognitoUtil.buildCognitoCredsForGoogle(jwtToken);
                        this.analyticsService.identify(sub);
                        resolve();
                    }
                    catch (err) {
                        console.log(err);
                    }
                },
                onFailure: error => {
                    console.log('Error: ' + error);
                    this.onFailureMethod();
                }
            }

            // goes to user handler
            this.auth.parseCognitoWebResponse(this.router.url);
        });
    }

    signedIn(session) {
        this.session = session;
    }

    onFailureMethod() {
        this.session = undefined;
    }

    get accessToken() {
        return this.session && this.session.getAccessToken().getJwtToken();
    }

    get isAuthenticated() {
        return this.auth.isUserSignedIn();
    }

    login() {
    }

    signOut() {
        this.auth.signOut();
    }

    constructGoogleHostedUIUrl() {
        return `${environment.appDomain}/oauth2/authorize?identity_provider=Google&redirect_uri=${environment.redirectSignIn}&response_type=TOKEN&client_id=${this.cognitoUtil.getUserPool().getClientId()}`;
    }

    constructAppleHostedUIUrl() {
        return `${environment.appDomain}/oauth2/authorize?identity_provider=SignInWithApple&redirect_uri=${environment.redirectSignIn}&response_type=TOKEN&client_id=${this.cognitoUtil.getUserPool().getClientId()}`;
    }
}